import type { AlertaProjeto } from "@/mocks/projetos";

interface Props {
  alertas: AlertaProjeto[];
}

const severidadeConfig: Record<string, { icon: string; iconColor: string; bgColor: string; borderColor: string; label: string }> = {
  critica: { icon: "ri-error-warning-line", iconColor: "text-danger-600", bgColor: "bg-danger-50", borderColor: "border-l-danger-500", label: "Crítico" },
  alta: { icon: "ri-alert-line", iconColor: "text-warning-600", bgColor: "bg-warning-50", borderColor: "border-l-warning-500", label: "Alto" },
  media: { icon: "ri-information-line", iconColor: "text-caution-600", bgColor: "bg-caution-50", borderColor: "border-l-caution-500", label: "Médio" },
};

export default function ProjectAlertsCard({ alertas }: Props) {
  if (alertas.length === 0) {
    return (
      <div className="flex items-center justify-center p-8 rounded-lg bg-primary-50 border border-primary-200">
        <div className="text-center">
          <i className="ri-check-line text-primary-500 text-xl"></i>
          <p className="text-sm text-primary-700 mt-1">Nenhum alerta ativo neste projeto.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {alertas.map((alerta, i) => {
        const cfg = severidadeConfig[alerta.severidade] || severidadeConfig.media;
        return (
          <div
            key={i}
            className={`flex items-start gap-3 p-3 rounded-lg border-l-2 ${cfg.borderColor} ${cfg.bgColor}`}
          >
            <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center shrink-0">
              <i className={`${cfg.icon} ${cfg.iconColor} text-sm`} aria-hidden="true"></i>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground-800 font-medium">{alerta.mensagem}</p>
              <div className="flex items-center gap-2 mt-1">
                <span className={`badge text-[10px] px-1.5 py-0 ${cfg.bgColor} ${cfg.iconColor}`}>{cfg.label}</span>
                <span className="text-xs text-foreground-500 tabular-nums">{alerta.quantidade} {alerta.quantidade === 1 ? "registro" : "registros"}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}